/* eslint-disable curly, no-unused-expressions, no-magic-numbers */
import Observer from 'utils/Observer';

/**
 * Default values for attribute and states.
 * @constant
 */
const ATTRIBUTE = 'data-toggle-active';
const ACTIVE_STATE = 'true';
const INACTIVE_STATE = 'false';
const ACTIVE_EVENT = 'active';
const INACTIVE_EVENT = 'inactive';

/**
 * Class Toggle.
 * @class
 */
class ToggleClose {

    /**
     * Make a new Toggle.
     * @constructs
     * @param {HTMLElement} element
     * @param {{}} options
     */
    constructor(element, options) {
        this._element = element;

        if (!element) return;
        this._options = options || {};
        this._options.attribute = this._options.attribute || ATTRIBUTE;
        this._options.activeState = this._options.activeState || ACTIVE_STATE;
        this._options.inActiveState = this._options.inActiveState || INACTIVE_STATE;
        this._id = this._element && this._element.getAttribute('id');
        this.active = false;
        this.body = document.body;
        this.switch = this.switch.bind(this);

        this._cacheSelectors();
        this._initialize();

    }

    /**
    * Cache selectors
    * @private
    */
    _cacheSelectors() {
        this._triggers = [...this._element.querySelectorAll(this._options.triggers)];
        this._hiddenLinks = [...this._element.querySelectorAll('[data-hide]')];
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {

        const attribute = this._element.getAttribute(this._options.attribute);
        if (!attribute) {
            this.attribute = this._options.inActiveState;
        } else if (attribute === this._options.activeState) {
            this.active = true;
        }
        this._hiddenLinks.forEach(link => link.setAttribute('aria-hidden', true));

        this._addListeners();
    }

    /**
     * Add listeners
     * @private
     */
    _addListeners() {

        this._triggers.forEach(trigger => {
            trigger.addEventListener('click', event => this.switch(event));
        });
    }

    /**
     * Add listeners
     * @private
     * @param {event} event
     */
    switch(event) {
        event.preventDefault();
        this.active ? this.deactivate() : this.activate();
    }


    /**
     * Activating the toggle by changing the attribute active value.
     * @public
     */
    activate() {
        this.attribute = this._options.activeState;
        this.active = true;
        this._element.setAttribute('data-active', ACTIVE_STATE);
        this._triggers.forEach(trigger => {
            trigger.setAttribute(`${this._options.attribute}`, ACTIVE_STATE);
        });
        this._hiddenLinks.forEach(link => link.removeAttribute('aria-hidden'));


        Observer.publish(this, ACTIVE_EVENT, this);
    }

    /**
     * Deactivating the toggle by changing the attribute inactive value.
     * @public
     */
    deactivate() {
        this.attribute = this._options.inActiveState;
        this.active = false;
        this._element.setAttribute('data-active', INACTIVE_STATE);
        this._triggers.forEach(trigger => {
            trigger.setAttribute(`${this._options.attribute}`, INACTIVE_STATE);
        });
        this._hiddenLinks.forEach(link => link.setAttribute('aria-hidden', true));

        Observer.publish(this, INACTIVE_EVENT, this);
    }

    /**
     * Expose the id.
     * @public
     */
    get id() {
        return this._id;
    }


    /**
     * Expose the toggle active event.
     * @public
     */
    // eslint-disable-next-line class-methods-use-this
    get activeEvent() {
        return ACTIVE_EVENT;
    }

    /**
     * Expose the toggle inactive event.
     * @public
     */
    // eslint-disable-next-line class-methods-use-this
    get inActiveEvent() {
        return INACTIVE_EVENT;
    }


}

export default ToggleClose;
